import restaurantService from '@/api/restaurant'
import { RESTAURANT } from '../types'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  state: {
    restaurants: [],
    restaurantsGroupedBySite: [],
    restaurantSiteId: null,
    devicesIds: [],
    blockAccessUponPriorRestaurantBooking: false,
    amountOfTablesCount: 0
  },
  getters: {
    siteRestaurants: (state) => {
      return state.restaurantsGroupedBySite.length > 0 && state.restaurantSiteId ? state.restaurantsGroupedBySite.find(site => site.id == state.restaurantSiteId).restaurants : []
    },
    restaurantSiteId: (state) => {
      return state.restaurantSiteId
    }
  },
  mutations: {
    [RESTAURANT.SET_RESTAURANTS] (state, restaurants) {
      state.restaurants = restaurants
    },
    [RESTAURANT.SET_RESTAURANTS_GROUPED_BY_SITE] (state, restaurantsGroupedBySite) {
      state.restaurantsGroupedBySite = restaurantsGroupedBySite
    },
    [RESTAURANT.SET_SITE_ID] (state, siteId) {
      state.restaurantSiteId = siteId
    },
    [RESTAURANT.SET_RESTAURANT_DEVICES] (state, devicesIds) {
      state.devicesIds = devicesIds
    },
    [RESTAURANT.SET_RESTAURANT_DEVICES_BLOCK_ACCESS] (state, blockAccessUponPriorRestaurantBooking) {
      state.blockAccessUponPriorRestaurantBooking = blockAccessUponPriorRestaurantBooking
    },
    [RESTAURANT.SET_AMOUNT_OF_TABLES_COUNT](state, amountOfTablesCount) {
      state.amountOfTablesCount = amountOfTablesCount
    }
  },
  actions: {
    async getRestaurantsList ({commit, dispatch}) {
      try {
        let response = await restaurantService.getRestaurants()
        const {restaurants, amountOfTablesCount} = response.data
        commit(RESTAURANT.SET_RESTAURANTS, restaurants)
        commit(RESTAURANT.SET_AMOUNT_OF_TABLES_COUNT, amountOfTablesCount)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getRestaurantsGroupedBySite ({commit, dispatch}) {
      return new Promise((resolve) => {
        restaurantService.getRestaurantsGroupedBySite().then(response => {
          commit(RESTAURANT.SET_RESTAURANTS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch(() => {
          commit(RESTAURANT.SET_RESTAURANTS_GROUPED_BY_SITE, [])
        }).finally(
          dispatch('Global/hideLoading', null, {root:true})
        )
      })
    },
    async getRestaurantsActiveGroupedBySite ({commit, dispatch}) {
      return new Promise((resolve) => {
        restaurantService.getRestaurantsActiveGroupedBySite().then(response => {
          commit(RESTAURANT.SET_RESTAURANTS_GROUPED_BY_SITE, response.data)
          resolve()
        }).catch(() => {
          commit(RESTAURANT.SET_RESTAURANTS_GROUPED_BY_SITE, [])
        }).finally(
          dispatch('Global/hideLoading', null, {root:true})
        )
      })
    },
    async addRestaurants ({dispatch}, restaurant) {
      try {
        await restaurantService.addRestaurant(restaurant)
        await dispatch('getRestaurantsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editRestaurants ({dispatch}, restaurant) {
      try {
        await restaurantService.editRestaurant(restaurant)
        await dispatch('getRestaurantsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    activateRestaurant: function (_, restaurant) {
      return new Promise((resolve, reject) => {
        restaurantService.activateRestaurant(restaurant).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    async deactivateRestaurant({ dispatch }, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await restaurantService.deactivateRestaurant(payload.restaurant, payload.cancelFutureBookings)
        dispatch('Global/showMessage', 'saveSucessful', { root: true })
      } catch (error) {
        errorhandler.handleError(error);
        throw error
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    setRestaurantSiteId ({commit}, siteId) {
      commit(RESTAURANT.SET_SITE_ID, siteId)
    },
    async getRestaurantDevices ({commit, dispatch}, restaurantId) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        let response = await restaurantService.getRestaurantDevices(restaurantId)
        commit(RESTAURANT.SET_RESTAURANT_DEVICES, response.data.devices? response.data.devices : [])
        commit(RESTAURANT.SET_RESTAURANT_DEVICES_BLOCK_ACCESS, response.data.blockAccessUponPriorRestaurantBooking)
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveRestaurantDevices ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, {root: true})
        await restaurantService.saveRestaurantDevices(payload.workPlaceId, payload.devicesIds, payload.blockAccessUponPriorBooking)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
        return Promise.reject(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getRestaurantIntegration ({dispatch}, restaurantId) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        let response = await restaurantService.getRestaurantIntegration(restaurantId)
        return response
      }
      catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveIntegration ({dispatch}, payload) {
      try {
        dispatch('Global/showLoading', null, { root: true })
        await restaurantService.saveIntegration(payload.restaurantId, payload.integration)
        dispatch('Global/showMessage', 'saveSucessful', {root: true})
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
  }
}
